import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .max(255, 'Email is too long')
    .required('Email is required'),
})

export default validationSchema
